import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HelpersService } from '@app/services/helpers.service';
import { NavService } from '@app/services/nav.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as Global from "@app/global"
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { ActivatedRoute, Router } from '@angular/router';
import { BranchService } from '../../../../../services/branch.service';
import { CompanyService } from '../../../../../services/company.service';
@Component({
  selector: 'table-filter',
  standalone: true,
  imports: [
    MatToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    MatSelectModule,
    NgSelectModule
  ],
  templateUrl: './table-filter.component.html',
  styleUrl: './table-filter.component.scss',
})
export class TableFilterComponent {
  Global = Global
  @Input() data: any = null;
  formGroup!: FormGroup;
  account_list: any = [];
  branch_list: any = [];
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public fb: FormBuilder,
    public navService: NavService,
    public helpers: HelpersService,
    private spinner: NgxSpinnerService,
    private branchService: BranchService,
    private companyService: CompanyService) {

  }
  ngOnInit() {
    this.fetchBranches();
    this.fetchAccounts();
  }
  ngOnChanges() {
    this.formGroup = this.fb.group({
      companyAccountId: [this.data?.formValue?.companyAccountId ?? null],
      branchId: [this.data?.formValue?.branchId ?? null],
      startDate: [this.data?.formValue?.startDate ? new Date(this.data?.formValue?.startDate) : null],
      endDate: [this.data?.formValue?.endDate ? new Date(this.data?.formValue?.endDate) : null],
    })
  }
  fetchBranches() {
    this.spinner.show();
    this.branchService.fetchBranches().subscribe({
      next: (res: any) => {
        this.branch_list = res;
      },
      error: (err) => {
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }
  fetchAccounts() {
    let params = new URLSearchParams();
    params.set('skip', '0')
    params.set('pageSize', '0')
    this.spinner.show();
    this.companyService.fetchCompnayAccounts({ params }).subscribe({
      next: (res: any) => {
        this.account_list = res.data;
      },
      error: (err) => {
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }
  onListTypeChange() {

  }
  applyFilter() {
    this.navService.openSideNav({ toogle: true, ...this.formGroup.getRawValue(), activity: 'table-filter', valueChange: true })
  }
  resetFilter() {
    this.formGroup.reset();
    this.applyFilter()

  }
}
